import { useState } from "react"
import { Modal, Text, Button, Stack, Title } from "@mantine/core"
import classes from "./BrandSelectorModal.module.css"
import { BrandSwitch } from "../BrandSwitch/BrandSwitch"
import { Brand } from "@utils/constants.util"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"

interface BrandSelectorModalProps {
	opened: boolean
	onClose: () => void
	onSelect: (brand: Brand) => void
	brands: Brand[]
}

export function BrandSelectorModal({
	opened,
	onClose,
	brands,
	onSelect
}: BrandSelectorModalProps) {
	const { dictionary } = useAEMDictionary()
	const [selectedBrand, setSelectedBrand] = useState<Brand | null>(null)

	const handleContinue = () => {
		if (selectedBrand) {
			onSelect(selectedBrand)
			onClose()
		}
	}

	return (
		dictionary && (
			<Modal
				opened={opened}
				onClose={onClose}
				centered
				classNames={{
					header: classes.header,
					title: classes.title,
					body: classes.body
				}}
			>
				<Stack align="center" gap="xl" justify="center" mb="xl">
					<Title className={classes.title} size="h5">
						{dictionary.brandModalHeading}
					</Title>
					<Text size="sm" ta="center">
						{dictionary.brandModalDescription}
					</Text>
					<BrandSwitch
						small={true}
						onSwitch={setSelectedBrand}
						availableBrands={brands}
					/>
					<Button
						size="lg"
						className={classes.continueButton}
						onClick={handleContinue}
						disabled={!selectedBrand}
					>
						{dictionary.brandModalContinue}
					</Button>
				</Stack>
			</Modal>
		)
	)
}
